import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationSampleTypeCreateRequest,
    ConfigurationSampleTypePatchInBatchRequest,
    ConfigurationSampleTypeResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-sample-type/configuration-sample-type.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationSampleTypeService {
    async create(request: ConfigurationSampleTypeCreateRequest): Promise<ConfigurationSampleTypeResponse> {
        const response = await axios.post<ConfigurationSampleTypeResponse>(`/configuration/sampleTypes`, request)
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationSampleTypeResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationSampleTypeResponse>>(`/configuration/sampleTypes`, { ...filterModel }, { params })
        return response.data
    }

    async get(sampleTypeId: number): Promise<ConfigurationSampleTypeResponse> {
        const response = await axios.get<ConfigurationSampleTypeResponse>(`/configuration/sampleTypes/${sampleTypeId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/sampleTypes/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationSampleTypePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/sampleTypes/batch`, request)
        return response.data
    }

    async search(query: string, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationSampleTypeResponse>> {
        const response = await axios.get<IResponseAgGrid<ConfigurationSampleTypeResponse>>(`/configuration/sampleTypes/search`, { params: { ...params, query } })
        return response.data
    }
}

export const configurationSampleTypeService = new ConfigurationSampleTypeService()
